function setSubdomainText() {
	let value = $("#subdomain").val();
	value = value.toLowerCase();

	value = value.replace(/[^a-zA-Z0-9-]/g, "");

	if(value.length > 25) {
		value = value.substring(0, 25);
	}

	$("#subdomain").val(value);

	if(!value) {
		value = "subdomain";
	}

	const host = value + ".apex27.co.uk";
	const text = "This will be how you log in, you'll visit " + host;

	$("#subdomain-text").text(text);
}

function startAllHomeCounters() {
	$({countNum: $('#sold-counter').html() }).animate({ countNum: $('#sold-counter-end').val()}, {
		duration: 8000,
		easing: 'linear',
		step: function() {
			$('#sold-counter').html(Math.floor(this.countNum).toLocaleString());
		},
		complete: function() {
			$('#sold-counter').html(this.countNum.toLocaleString());
		}
	});

	$({countNum: $('#applicants-counter').html() }).animate({ countNum: $('#applicants-counter-end').val()}, {
		duration: 8000,
		easing: 'linear',
		step: function() {
			$('#applicants-counter').html(Math.floor(this.countNum).toLocaleString());
		},
		complete: function() {
			$('#applicants-counter').html(this.countNum.toLocaleString());
		}
	});

	$({countNum: $('#tenancies-counter').html() }).animate({ countNum: $('#tenancies-counter-end').val()}, {
		duration: 8000,
		easing: 'linear',
		step: function() {
			$('#tenancies-counter').html(Math.floor(this.countNum).toLocaleString());
		},
		complete: function() {
			$('#tenancies-counter').html(this.countNum.toLocaleString());
		}
	});

	$({countNum: $('#integrations-counter').html() }).animate({ countNum: $('#integrations-counter-end').val()}, {
		duration: 8000,
		easing: 'linear',
		step: function() {
			$('#integrations-counter').html(Math.floor(this.countNum).toLocaleString());
		},
		complete: function() {
			$('#integrations-counter').html(this.countNum.toLocaleString());
		}
	});

	$({countNum: $('#leads-counter').html() }).animate({ countNum: $('#leads-counter-end').val()}, {
		duration: 8000,
		easing: 'linear',
		step: function() {
			$('#leads-counter').html(Math.floor(this.countNum).toLocaleString());
		},
		complete: function() {
			$('#leads-counter').html(this.countNum.toLocaleString());
		}
	});

	$({countNum: $('#documents-counter').html() }).animate({ countNum: $('#documents-counter-end').val()}, {
		duration: 8000,
		easing: 'linear',
		step: function() {
			$('#documents-counter').html(Math.floor(this.countNum).toLocaleString());
		},
		complete: function() {
			$('#documents-counter').html(this.countNum.toLocaleString());
		}
	});

	$({countNum: $('#portals-counter').html() }).animate({ countNum: $('#portals-counter-end').val()}, {
		duration: 8000,
		easing: 'linear',
		step: function() {
			$('#portals-counter').html(Math.floor(this.countNum).toLocaleString());
		},
		complete: function() {
			$('#portals-counter').html(this.countNum.toLocaleString());
		}
	});

	$({countNum: $('#chains-counter').html() }).animate({ countNum: $('#chains-counter-end').val()}, {
		duration: 8000,
		easing: 'linear',
		step: function() {
			$('#chains-counter').html(Math.floor(this.countNum).toLocaleString());
		},
		complete: function() {
			$('#chains-counter').html(this.countNum.toLocaleString());
		}
	});
}

function startAllAboutCounters() {
	$({countNum: $('#sales-counter').html() }).animate({ countNum: $('#sales-counter-end').val()}, {
		duration: 8000,
		easing: 'linear',
		step: function() {
			$('#sales-counter').html(Math.floor(this.countNum).toLocaleString());
		},
		complete: function() {
			$('#sales-counter').html(this.countNum.toLocaleString());
		}
	});

	$({countNum: $('#lettings-counter').html() }).animate({ countNum: $('#lettings-counter-end').val()}, {
		duration: 8000,
		easing: 'linear',
		step: function() {
			$('#lettings-counter').html(Math.floor(this.countNum).toLocaleString());
		},
		complete: function() {
			$('#lettings-counter').html(this.countNum.toLocaleString());
		}
	});

	$({countNum: $('#commercial-counter').html() }).animate({ countNum: $('#commercial-counter-end').val()}, {
		duration: 8000,
		easing: 'linear',
		step: function() {
			$('#commercial-counter').html(Math.floor(this.countNum).toLocaleString());
		},
		complete: function() {
			$('#commercial-counter').html(this.countNum.toLocaleString());
		}
	});

	$({countNum: $('#land-counter').html() }).animate({ countNum: $('#land-counter-end').val()}, {
		duration: 8000,
		easing: 'linear',
		step: function() {
			$('#land-counter').html(Math.floor(this.countNum).toLocaleString());
		},
		complete: function() {
			$('#land-counter').html(this.countNum.toLocaleString());
		}
	});
}

function loadVideo(elem, url) {
	const videoContainer = $(elem);
	const videoContainerImg = $(elem + "-img");
	if(videoContainer.length && videoContainerImg.length) {

		videoContainerImg.on("click", event => {
			videoContainerImg.addClass("d-none");

			let video = $("<iframe/>");
			video.attr({
				src: url + "?autoplay=1",
				frameborder: 0,
				class: "embed-responsive-item",
				allow: "autoplay"
			});
			videoContainer.append(video);
		});
	}
	else if(videoContainer.length) {
		let video = $("<iframe/>");
		video.attr({
			src: url,
			frameborder: 0,
			class: "embed-responsive-item",
		});
		videoContainer.append(video);
	}
}

function deferImages() {
	const imgDefer = document.querySelectorAll('div[data-src]');
	let style = "background-image: url({url}); background-position: center center; background-repeat:no-repeat;";
	for (let i = 0; i < imgDefer.length; i++) {
		imgDefer[i].setAttribute("style", style.replace("{url}", imgDefer[i].getAttribute("data-src")));
	}

}

$(() => {
	// reCaptcha
	$("#recaptcha-form").on("submit", event => {
		const tokenInput = $("#recaptcha-token");

		if(tokenInput.val() == "") {
			event.preventDefault();

			if($("#recaptcha-key").length) {
				grecaptcha.ready(function() {
					grecaptcha.execute($("#recaptcha-key").val(), {action: 'login'}).then(function(token) {
						tokenInput.val(token);
						$("#recaptcha-button").click();
					});
				});
			}
		}
	});

	$("#slideshow > div:gt(0)").hide();

	setInterval(function() {
		$('#slideshow > div:first')
			.fadeOut(1000)
			.next()
			.fadeIn(1000)
			.end()
			.appendTo('#slideshow');
	}, 6000);

	// Top nav
	$("#top-nav-home").click(() => {
		window.location.href = "/";
	});

	// Sign up
	$("#business-name").bind("keyup change", event => {
		const businessNameValue = $(event.currentTarget).val();
		let subdomainValue = businessNameValue.replace(/[^a-z0-9]/gi, "");
		subdomainValue = subdomainValue.toLowerCase();

		$("#subdomain").val(subdomainValue);
		setSubdomainText();
	});

	$("#subdomain").bind("keyup change", event => {
		setSubdomainText();
	});


	$("#postcode-lookup").on("click", event => {

		event.preventDefault();

		const $field = $("#postal-code");
		const $button = $("#postcode-lookup");

		let postcode = $field.val();
		postcode = postcode.replace(/\s/g, "");

		if(!postcode) {
			$field.css("background-color", "red");
			return;
		}

		$button.html("Searching...");
		$field.css("background-color", "white");

		$.get("/postcode-lookup", {
			postcode: postcode
		}).then(response => {

			const dropdown = $("#address-list-div select");
			$(dropdown).find("option[data-address]").remove();

			if(!response.success) {
				$button.html("Failed");
			}

			// Reset button
			$button.html("Lookup");

			// Show list
			$("#address-list-div").removeClass("d-none");

			// Populate dropdown
			$.each(response.addresses, (index, address) => {
				const option = $(`<option data-address value="">${address.display}</option>`);
				option.data("address", address);
				dropdown.append(option);
			});

		});
	});


	$("#address-list").on("change", event => {
		const address = $(event.currentTarget).find("option:selected").data("address");
		if(!address) return true;

		$("#address-1").val(address.address1);
		$("#address-2").val(address.address2);
		$("#city").val(address.city);
		$("#county").val(address.county).trigger("change");
	});

	// Start counters
	if($('#scroll-to').length) {
		let startCounters = true;
		$(window).on("scroll", function() {
			if(startCounters) {
				var hT = $('#scroll-to').offset().top,
				hH = $('#scroll-to').outerHeight(),
				wH = $(window).height(),
				wS = $(this).scrollTop();
				if (wS > (hT+hH-wH)){
					startCounters = false;

					if($('#documents-counter').length > 0) {
						startAllHomeCounters();
					}
					else {
						startAllAboutCounters();
					}
				}
			}
		});
	}

	loadVideo("#introduction-video-container", "https://www.youtube.com/embed/T85KnH7x_sc");
	loadVideo("#chatgpt-video-container", "https://www.youtube.com/embed/aT7t0PCWmZw");
	loadVideo("#what3words-video-container", "https://www.youtube.com/embed/yFylemoI4hw");

	deferImages();
});
